module.exports = __webpack_public_path__ + "img/FR19906.3686dfcd.png";